import { StyleSheet } from 'aphrodite'

import navbar from './navbar'
import social from './social'
import authbar from './authbar'

export default {
  navbar: StyleSheet.create(navbar),
  social: StyleSheet.create(social),
  authbar: StyleSheet.create(authbar)
}



// WEBPACK FOOTER //
// ./src/components/partials/Header/style/index.js